module.exports = __webpack_public_path__ + "static/media/approve.7c360be5.png";